/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Search_AriaInputs */

const en_common_header_search_aria = /** @type {(inputs: Common_Header_Search_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search products`)
};

const zh_common_header_search_aria = /** @type {(inputs: Common_Header_Search_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索产品`)
};

/**
* | output |
* | --- |
* | "Search products" |
*
* @param {Common_Header_Search_AriaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_search_aria = /** @type {((inputs?: Common_Header_Search_AriaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Search_AriaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_search_aria(inputs)
	return zh_common_header_search_aria(inputs)
});
export { common_header_search_aria as "common.header.search_aria" }